function WhtCertificateAccess(can: any, data: any) {
  if (data) {
    if (data.approve) can("create", "Wht_Approve");
    if (data.create) can("create", "Wht_Create");
    if (data.delete) can("create", "Wht_Delete");
    if (data.edit) can("create", "Wht_Edit");
    if (data.view) {
      can("create", "Wht_View");
      can("access", "WhtCertificate_Menu");
      can("access", "Wht_Menu");
    }
  }
}

function Pnd1Access(can: any, data: any) {
  if (data) {
    if (data.approve) can("create", "Pnd1_Approve");
    if (data.create) can("create", "Pnd1_Create");
    if (data.delete) can("create", "Pnd1_Delete");
    if (data.edit) can("create", "Pnd1_Edit");
    if (data.view) {
      can("create", "Pnd1_View");
      can("access", "Pnd1_Menu");
      can("access", "Wht_Menu");
    }
  }
}

function Pnd2Access(can: any, data: any) {
  if (data) {
    if (data.approve) can("create", "Pnd2_Approve");
    if (data.create) can("create", "Pnd2_Create");
    if (data.delete) can("create", "Pnd2_Delete");
    if (data.edit) can("create", "Pnd2_Edit");
    if (data.view) {
      can("create", "Pnd2_View");
      can("access", "Pnd2_Menu");
      can("access", "Wht_Menu");
    }
  }
}

function Pnd3Access(can: any, data: any) {
  if (data) {
    if (data.approve) can("create", "Pnd3_Approve");
    if (data.create) can("create", "Pnd3_Create");
    if (data.delete) can("create", "Pnd3_Delete");
    if (data.edit) can("create", "Pnd3_Edit");
    if (data.view) {
      can("create", "Pnd3_View");
      can("access", "Pnd3_Menu");
      can("access", "Wht_Menu");
    }
  }
}

function Pnd53Access(can: any, data: any) {
  if (data) {
    if (data.approve) can("create", "Pnd53_Approve");
    if (data.create) can("create", "Pnd53_Create");
    if (data.delete) can("create", "Pnd53_Delete");
    if (data.edit) can("create", "Pnd53_Edit");
    if (data.view) {
      can("create", "Pnd53_View");
      can("access", "Pnd53_Menu");
      can("access", "Wht_Menu");
    }
  }
}

function ExportWhtCertificateAndPnd(can: any) {
  can("create", "Export_Wht");
  can("create", "Export_Pnd");
}

function PndAccessToPeak(can: any) {
  can("accessData", "Pnd_Access_To_Peak");
}

function PndPaymentAccess(can: any) {
  can("accessData", "Pnd_Payment_Access");
}

function PndFilingAccess(can: any) {
  can("accessData", "Pnd_Tax_Filing");
}

function ManageWhtCertificateAndPnd(manageWht: any, can: any) {
  const { accessToPeak, paid, payment, pnd1, pnd2, pnd3, pnd53, report, taxFiling, whtCerificate } = manageWht;

  WhtCertificateAccess(can, whtCerificate);
  Pnd1Access(can, pnd1);
  Pnd2Access(can, pnd2);
  Pnd3Access(can, pnd3);
  Pnd53Access(can, pnd53);
  if (accessToPeak && accessToPeak.accessToPeak) PndAccessToPeak(can);
  if (payment && payment.payment) PndPaymentAccess(can);
  if (report && report.print) ExportWhtCertificateAndPnd(can);
  if (taxFiling && taxFiling.taxFiling) PndFilingAccess(can);
}
export { ManageWhtCertificateAndPnd };
